import { AuctionData } from 'components/Listing/ListingContextSection';
import { APIListingItem } from '../types';

/**
 * Maps over an API Listing's subStatus and selects the relevant date to pass through for rendering in listing card.
 */
export function mapAuctionData(apiListing: APIListingItem): AuctionData {
  switch (apiListing.subStatus) {
    case 'MakeAnOffer':
      return {
        type: 'offer',
        count: apiListing.numberOfOffers ?? 0,
        views: apiListing.numberOfViews ?? 0,
        watchers: apiListing.numberOfWatchers ?? 0,
        auctionRef: apiListing.listingSku,
      };
    case 'Auction':
    case 'Negotiable':
    case 'Referred':
    default:
      return {
        type: 'bid',
        count: apiListing.numberOfBids ?? 0,
        views: apiListing.numberOfViews ?? 0,
        watchers: apiListing.numberOfWatchers ?? 0,
        auctionRef: apiListing.listingSku,
      };
  }
}
